import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Blog = () => {
    const [form, setForm] = useState({
        content: '',
        title: '',
        name: '',
        email: '',
        website: '',
        remember: false,
    });

    const [blogs, setBlogs] = useState([]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm({
            ...form,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await axios.post('http://localhost:5000/api/blog', form);
            alert("Message sent successfully!");
            setForm({ content: '', title: '', name: '', email: '', website: '', remember: false });
        } catch (error) {
            console.error("Error sending message:", error);
            alert("Failed to send message. Please try again.");
        }
    };

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const res = await axios.get('http://localhost:5000/api/approved-blogs');
                setBlogs(res.data);
            } catch (error) {
                console.error("Error fetching blogs:", error);
            }
        };

        fetchBlogs();
    }, []);

    return (
        <>
            <div className="container mt-2">
                <h2 className="mb-4" style={{ color: '#043b72' }}>Blogs</h2>
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4 g-4 mb-3">
                    {blogs.map((blog, index) => (
                        <div className="col" key={index}>
                            <div className="card h-100 shadow-sm border-0">
                                <div className="card-body">
                                    <h5 className="card-title" style={{ color: '#043b72' }}>{blog.title}</h5>
                                    <p className="card-text" style={{ fontSize: '0.95rem' }}>{blog.content}</p>
                                </div>
                                <div className="card-footer bg-white border-0">
                                    <small className="text-muted">By <strong>{blog.name}</strong></small><br />
                                    <small className="text-muted">On {new Date(blog.approvedAt).toLocaleDateString()}</small>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className='border-bottom'></div>

                <h2 className="mb-4" style={{ color: '#043b72' }}>Leave a Reply</h2>
                <p>Your email address will not be published. Required fields are marked <span className="text-danger">*</span></p>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="comment" className="form-label">Comment <span className="text-danger">*</span></label>
                        <textarea
                            className="form-control"
                            id="content"
                            name="content"
                            rows="4"
                            required
                            value={form.content}
                            onChange={handleChange}
                            placeholder="supportive staff, reasonable price."
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="title" className="form-label">Title <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            id="title"
                            name="title"
                            required
                            value={form.title}
                            onChange={handleChange}
                            placeholder="Enter title"
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="name" className="form-label">Name <span className="text-danger">*</span></label>
                        <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            required
                            value={form.name}
                            onChange={handleChange}
                            placeholder="Enter name"
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email <span className="text-danger">*</span></label>
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            required
                            value={form.email}
                            onChange={handleChange}
                            placeholder="Enter email"
                        />
                    </div>

                    <div className="mb-3">
                        <label htmlFor="website" className="form-label">Website</label>
                        <input
                            type="url"
                            className="form-control"
                            id="website"
                            name="website"
                            value={form.website}
                            onChange={handleChange}
                            placeholder="https://example.com"
                        />
                    </div>

                    <div className="form-check mb-4">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="remember"
                            name="remember"
                            checked={form.remember}
                            onChange={handleChange}
                        />
                        <label className="form-check-label" htmlFor="remember">
                            Save my email, and website in this browser for the next time I comment.
                        </label>
                    </div>

                    <button type="submit" className="btn btn-primary mb-3">Post Comment</button>
                </form>
            </div>
        </>
    );
};

export default Blog;
